import React, { useState } from "react";
import { DownCircleOutlined, UpCircleOutlined, InfoCircleOutlined } from "@ant-design/icons";
import "./CategoryPage.css";

const RegistrationItem = ({ registration, onRegister, onShowInfo }) => {
  const [expanded, setExpanded] = useState(false);

  const { id, registration_name, registration_description, status, no_registration_required, homepage_info } = registration;
  const isOpen = status === "1" || status === 1;
  const noRegRequired = no_registration_required === "1" || no_registration_required === 1;

  const toggleExpanded = () => {
    setExpanded(!expanded);
  };

  return (
    <div className="registration-item">
      <div className="registration-header">
        <button 
          className={`expand-btn ${expanded ? 'expanded' : ''}`} 
          onClick={toggleExpanded}
          aria-label="Toggle description"
          title={expanded ? 'Hide details' : 'Show details'}
        >
          {expanded ? (
            <UpCircleOutlined className="arrow-icon" />
          ) : (
            <DownCircleOutlined className="arrow-icon" />
          )}
        </button>
        
        <h3 className="registration-name">{registration_name}</h3>
        
        <div className="registration-actions">
          {homepage_info && (
            <button
              className="info-btn"
              onClick={() => onShowInfo(homepage_info, id)}
              title="More Information"
            >
              <InfoCircleOutlined />
            </button>
          )}
          
          {noRegRequired ? (
            <button
              className="register-btn no-reg-required"
              disabled={true}
            >
              NO REGISTRATION REQUIRED
            </button>
          ) : (
            <button
              className={`register-btn ${isOpen ? 'open' : 'closed'}`}
              disabled={!isOpen}
              onClick={() => isOpen && onRegister(id)}
            >
              {isOpen ? 'REGISTER' : 'CLOSED'}
            </button>
          )}
        </div>
      </div>
      
      {expanded && (
        <div className="registration-description">
          {registration_description && registration_description.trim() !== '' ? (
            <p style={{ whiteSpace: 'pre-line' }}>
              {registration_description.replace(/\\n/g, '\n')}
            </p>
          ) : (
            <p>Description not currently available for this Registration</p>
          )}
        </div>
      )}
    </div>
  );
};

export default RegistrationItem;
